/**
 * Desktop header search — open/close behaviour for the predictive panel.
 *
 * search.js owns fetching and rendering: it sets `results` on the form once a
 * response lands and drops it on reset. It has no concept of a panel that
 * floats over the page, though — inside the drawer the list is simply always
 * visible — so the dismiss rules live here.
 */
class GwHeaderSearch extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.input = this.querySelector('input[type="search"]');
    if (!this.form || !this.input) return;

    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.sync = this.sync.bind(this);

    this.input.addEventListener('focus', this.sync);
    this.input.addEventListener('input', this.sync);
    this.addEventListener('keydown', this.onKeydown);
    document.addEventListener('click', this.onDocumentClick);

    // search.js toggles `results` asynchronously, after the fetch resolves.
    this.observer = new MutationObserver(this.sync);
    this.observer.observe(this.form, { attributes: true, attributeFilter: ['results'] });
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    document.removeEventListener('click', this.onDocumentClick);
  }

  get hasQuery() {
    return this.input.value.trim().length > 0;
  }

  sync() {
    this.hasQuery && this.form.hasAttribute('results') ? this.open() : this.close();
  }

  open() {
    this.setAttribute('open', '');
  }

  close() {
    this.removeAttribute('open');
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) this.close();
  }

  onKeydown(event) {
    if (event.key !== 'Escape') return;

    this.close();
    this.input.focus();
  }
}
customElements.define('gw-header-search', GwHeaderSearch);
